module.exports = __webpack_public_path__ + "static/img/eq_ico2.fdeb403.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/eq_ico2.png
// module id = A0PX
// module chunks = 37